import { NotesListBaseDataProvider } from './NotesListBaseDataProvider';
import { CreateNoteRequest, DeleteNoteRequest, UpdateNoteRequest } from '../types';
import { getRequestDefaultOptions } from '../../../utils/request.utils';
import { Note } from '../../types';

export class NotesListNirvanaDataProvider extends NotesListBaseDataProvider {
  public async getNotes(): Promise<Note[]> {
    const notes = await this.dependencies.api.clients.Notes.readRecords(
      { [this.getResourceIdApiField()]: this.dependencies.resourceId, isGzDemo: this.dependencies.isGzDemo },
      getRequestDefaultOptions()
    );

    return this.buildDataForView(notes);
  }

  public async createNote(request: CreateNoteRequest): Promise<void> {
    const payload: any = { text: request.text, [this.getResourceIdApiField()]: this.dependencies.resourceId };

    if (this.dependencies.isGzDemo) {
      const user = this.dependencies.getUser(), created = new Date().toISOString();

      Object.assign(payload, {
        _id: 'demoId' + Math.random() * 5,
        user: {
          _id: user._id,
          name: user.userName,
          company: {
            _id: user.company.id,
            name: user.company.name,
          },
        },
        created,
        lastUpdated: created,
        isGzDemo: true,
      });
    }

    await this.dependencies.api.clients.Notes.createRecord(payload, getRequestDefaultOptions());
  }

  public async updateNote(request: UpdateNoteRequest): Promise<void> {
    await this.dependencies.api.clients.Notes.updateRecord(
      { id: request._id, text: request.text, isGzDemo: this.dependencies.isGzDemo },
      getRequestDefaultOptions()
    );
  }

  public async deleteNote(request: DeleteNoteRequest): Promise<void> {
    await this.dependencies.api.clients.Notes.deleteRecord(
      { id: request._id, isGzDemo: this.dependencies.isGzDemo },
      getRequestDefaultOptions()
    );
  }
}
